import { httpClient } from '@/shared/services/http-client'
import { loadingService } from '@/shared/services/loading-service'

export const powerbiExportState = {
  namespaced: true,
  state: {
    availableExports: [],
    documentContent: null,
    availableFilters: [],
    teacherRolesList: []
  },
  mutations: {

    setAvailableExports(state, data) {
      state.availableExports = data;
    },

    clearDocumentContent(state) {
      state.documentContent = null;
    },

    setDocumentContent(state, data) {
      state.documentContent = data;
    },

    setAvailableFilters(state, data) {
      state.availableFilters = data;
    },

    setTeacherRolesList(state: any, data: any) { state.teacherRolesList = data; }

  },
  actions: {
    async getUserOptions(context, entityId) {
      const url = `/powerbiExport/UserOptionsList/${entityId}`
      loadingService.showLoading(true);

      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'data': data, 'errorMessage': '' };
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },

    async getExportList(context, entityId) {
      const url = `/powerbiExport/ExportPageList/${entityId}`
      loadingService.showLoading(true);

      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          //data = {"export_list": [{"id": "10001", "name": "Export Student Reports"}]};
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            context.commit('setAvailableExports', data.export_list)

          }
          else {
            result.success = false;
            result.errorMessage = 'Error retrieve export list';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },

    async clearDocumentContent(context, params) {
      context.commit('clearDocumentContent')
    },

    async getDocumentContent(context, params) {
      const url = `/powerbiExport/ExportContent/${params.entityId}/${params.exportId}?subject=${encodeURIComponent(params.subject)}&year=${params.year}&year_level=${params.year_level}&class_name=${params.class_name}&term=${params.term}`

      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (data) {
            context.commit('setDocumentContent', data)
          }
          else {
            result.success = false;
            result.errorMessage = 'Error retrieve document content';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async getTeacherRolesList(context) {
      const url = `/powerbiExport/teacherRolesList`
      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          if (data && data.message != 'Internal Errors') {
            context.commit('setTeacherRolesList', data)
          }
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async createTeacherRoles(context, params) {
      const url = `/powerbiExport/teacherRolesList`
      loadingService.showLoading(true);

      return await httpClient.post(url, params)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async createExportReport(context, params) {
      const url = `/powerbiExport/ExportPageList/${params.entity_id}`
      loadingService.showLoading(true);

      return await httpClient.post(url, params)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async deleteExportReport(context, params) {
      const url = `/powerbiExport/ExportPageList/${params.entity_id}?id=${params.id}`
      loadingService.showLoading(true);

      return await httpClient.delete(url)
        .then(res => {
          //const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };
          return result;
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async deleteTeacherRoles(context, params) {
      const url = `/powerbiExport/teacherRolesList?id=${params.id}`
      loadingService.showLoading(true);

      return await httpClient.delete(url)
        .then(res => {
          //const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };
          return result;
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    //entityId, export_id
    async getFilters(context, params) {

      const url = `powerbiExport/GetFilters/${params.entityId}/${params.export_id}`
      loadingService.showLoading(true);

      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (data) {

            context.commit('setAvailableFilters', data)
          }
          else {
            result.success = false;
            result.errorMessage = 'Error retrieve export list';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    }



  }

}
